(function() { window.GUID_c35c4e40_786f_4d54_bee1_470634a93d2c = { getGuid: function() { return "c35c4e40-786f-4d54-bee1-470634a93d2c"; } }; })();
var MasterPage;
(function (MasterPage) {
    var desktop;
    (function (desktop) {
        var masterUser = $('#MasterUser');
        masterUser.slideDown(); /*Patch contre le bug de chrome qui affiche pas le login au complet*/
        var leftSplitter = $('#MasterLeftSplitter');
        var rightSplitter = $('#MasterRightSplitter');
        var leftPanel = $('#MasterLeftPanel');
        var rightPanel = $('#MasterRightPanel');
        var toolBarContainer = $('#ToolBarContainer');
        var toolBar = $('#ToolBar', toolBarContainer);
        var forcedInMoreOptionsButtons = $('.InMoreOptions', toolBar);
        var moreOptionButton = $('#MoreOptionButton');
        var toolBarContainerZIndex = toolBarContainer.css('z-index');
        var masterBody = $('#MasterBody');
        //var MasterSearch = $('#MasterSearch');
        //var MasterSearchHidden = $('#TxtMasterSearch', MasterSearch);
        //var TxtMasterSearch = $('#TxtMasterSearchAutoComplete', MasterSearch);
        //var imgMasterSearch = $('#ImgMasterSearch', MasterSearch);
        var keyboardShortcutsButton = $('#KeyboardShortcutsButton');
        var keyboardShortcuts = $('#KeyboardShortcuts');
        var akForHelpButton = $('#AskForHelpButton');
        var leftPanelWidth = 0;
        var startRightPanelX = 0;
        var rightPanelWidth = 0;
        akForHelpButton.on('click', function () {
            var popup = new CompuSport.Controls.Popup();
            popup.GetAndShow({
                PopupId: "AskForHelp",
                Url: CSParameters.BaseUrl + 'Global/AskForHelp/' + CSParameters.SportEventId,
                AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
            });
        });
        leftSplitter.on('mousedown', function (e) {
            let startLeftPanelX = e.pageX;
            leftPanelWidth = leftPanel.width();
            var lastWidth = leftPanelWidth;
            CS.doc.on('mousemove.masterpage', function (e) {
                var widthOffset = startLeftPanelX - e.pageX;
                lastWidth = leftPanelWidth - widthOffset;
                if (lastWidth > 30) {
                    leftPanel.width(lastWidth);
                    leftSplitter.css('left', lastWidth);
                    masterBody.css('left', lastWidth);
                }
            }).on('mouseup.masterpage', function () {
                CS.doc.off('mousemove.masterpage');
                CS.doc.off('mouseup.masterpage');
                var data = {
                    keyName: 'MasterSplitterLeft',
                    value: lastWidth,
                    noSportEventId: true
                };
                if (CSParameters.IsConnected) {
                    CompuSport.Ajax.Post(CSParameters.ControllerUrl + 'SaveUserData/' + CSParameters.SportEventId, data);
                }
            });
        }).on('dblclick', function () {
            let width = leftPanel.width();
            if (width < 50) {
                width = 200;
            }
            else {
                width = 30;
            }
            leftPanel.width(width);
            leftSplitter.css('left', width);
            masterBody.css('left', width);
        });
        rightSplitter.on('mousedown', function (e) {
            startRightPanelX = e.pageX;
            rightPanelWidth = rightPanel.width();
            var lastWidth = rightPanelWidth;
            CS.doc.on('mousemove.masterpage', function (e) {
                var widthOffset = startRightPanelX - e.pageX;
                lastWidth = rightPanelWidth + widthOffset;
                if (lastWidth > 30) {
                    rightPanel.width(lastWidth);
                    rightSplitter.css('right', lastWidth);
                    masterBody.css('right', lastWidth);
                }
            }).on('mouseup.masterpage', function () {
                CS.doc.off('mousemove.masterpage');
                CS.doc.off('mouseup.masterpage');
                var data = {
                    keyName: 'MasterSplitterRight',
                    value: lastWidth,
                    noSportEventId: true
                };
                if (CSParameters.IsConnected) {
                    CompuSport.Ajax.Post(CSParameters.ControllerUrl + 'SaveUserData/' + CSParameters.SportEventId, data);
                }
            });
        });
        moreOptionButton.on('click', 'a', function (e) {
            e.preventDefault();
            toolBarContainer.toggleClass('IsOpened');
            if (toolBarContainer.hasClass('IsOpened')) {
                toolBarContainer.css('z-index', 104);
                forcedInMoreOptionsButtons.show();
            }
            else {
                toolBarContainer.css('z-index', toolBarContainerZIndex);
                forcedInMoreOptionsButtons.hide();
            }
        });
        CS.win.resize(function () {
            UpdateVisibilityOfMoreOptionButton();
        });
        UpdateVisibilityOfMoreOptionButton();
        function UpdateVisibilityOfMoreOptionButton() {
            if (toolBar.height() > 70 || forcedInMoreOptionsButtons.length > 0) {
                moreOptionButton.show();
            }
            else {
                moreOptionButton.hide();
            }
        }
        CS.doc.on('keydown.masterpage', function (e) {
            if (e.ctrlKey == true) {
                if (e.keyCode == 77 /*m*/) {
                    e.preventDefault();
                    Menu.ShowHideMenu(Menu.mainMenu.css('display') == "none");
                }
                else if (e.keyCode == 76 /*L*/) {
                    e.preventDefault();
                    ShowHideKeyboardShortcuts();
                }
            }
        });
        keyboardShortcutsButton.on('click', function () {
            ShowHideKeyboardShortcuts();
        });
        function ShowHideKeyboardShortcuts() {
            keyboardShortcuts.slideToggle();
        }
        var accountStatement = $('#AccountStatement');
        if (accountStatement.length > 0) {
            accountStatement.slideDown();
            accountStatement.on('click', function (e) {
                var target = $(e.target);
                if (target.hasClass("CloseAccountStatement")) {
                    var url = CSParameters.BaseUrl + 'Global/SnoozeUserAccountStatement/' + CSParameters.SportEventId;
                    CompuSport.Ajax.Post(url, null, function (response) {
                        if (response == "OK") {
                            accountStatement.slideUp();
                        }
                    });
                }
                else if (target.hasClass("ClickHereToSeeDetails")) {
                    document.location.href = window.location.protocol + '//' + window.location.host + CSParameters.BaseUrl + 'MyInvoices/Index/' + CSParameters.SportEventId;
                }
            });
        }
    })(desktop = MasterPage.desktop || (MasterPage.desktop = {}));
})(MasterPage || (MasterPage = {}));

//# sourceMappingURL=MasterPage.desktop.js.map
